import { Controller } from "stimulus"
import { postIntroExamBooking } from "../bundles/application/utils/google_tag_management";

export default class extends Controller {
  static targets = ["step", "previousButton", "nextButton"]

  static values = {
    index: Number,
    submit: String,
    disableWith: String,
  };

  connect() {
    this.element.noValidate = true
  }

  submit(event) {
    if (!this.checkValidity()) {
      event.preventDefault()
    } else if (this.hasNextStep) {
      event.preventDefault()
      this.next()
      if (this.indexValue == this.stepTargets.length - 1) {
        this.submitButton.disabled = true
      }
    } else if (this.submitButton) {
      this.submitButton.disabled = true
      this.submitButton.innerText = this.disableWithValue || 'Submitting...'

      // Pass form data to GTM data layer
      let form = document.querySelector('form');
      const data = new FormData(form);
      var formObject = {};
      data.forEach((value, key) => formObject[key] = value);
      
      postIntroExamBooking(
        formObject["appointment[patient_attributes][client_attributes][email]"],
        formObject["appointment[patient_attributes][client_attributes][firstname]"],
        formObject["appointment[patient_attributes][client_attributes][lastname]"],
        formObject["appointment[patient_attributes][client_attributes][mobile_phone]"],
      )
    }
  }

  checkValidity() {
    let invalidInput
    let idsToValidate = ['intro-first-name', 'intro-last-name', 'intro-pet-name']

    for (let inputIndex = 0; inputIndex < this.element.elements.length; inputIndex++) {
      const input = this.element.elements[inputIndex]
      // Check if first, last, and pet name contains only spaces and show error if so
      if (input.nodeName === 'INPUT' && this.currentStepTarget.contains(input) && idsToValidate.includes(input.id)) {
        
        input.setCustomValidity('')
        
        if (!input.value.replace(/\s/g, '').length) {
          invalidInput = input
          input.setCustomValidity('Please fill out this field.')
          break
        }
      }
      if (input.nodeName === 'INPUT' && this.currentStepTarget.contains(input) && !input.checkValidity()) {
        invalidInput = input
        break
      }
    }

    if (invalidInput) {
      invalidInput.reportValidity()
      return false
    }

    return true
  }

  next() {
    this.indexValue++
  }

  previous() {
    this.indexValue--
  }

  indexValueChanged() {
    this.showCurrentStep()
    this.toggleStepButtons()
  }

  showCurrentStep() {
    this.stepTargets.forEach(
      (element, index) => element.hidden = index !== this.indexValue
    )
  }

  toggleStepButtons() {
    if (this.hasPreviousButtonTarget) {
      this.previousButtonTarget.style.visibility = this.indexValue === 0 ? "hidden" : "visible"
    }

    if (this.hasSubmitTarget && this.hasSubmitValue) {
      if (this.indexValue >= this.stepTargets.length - 1) {
        this.submitTarget.hiddenText = this.submitTarget.innerText
        this.submitTarget.innerText = this.submitValue
      } else if (this.submitTarget.hiddenText) {
        this.submitTarget.innerText = this.submitTarget.hiddenText
      }
    }
  }

  get currentStepTarget() {
    return this.stepTargets[this.indexValue]
  }

  get hasNextStep() {
    return this.indexValue < this.stepTargets.length - 1
  }

  get submitButton() {
    return this.element.button
  }
}
